module.exports = __webpack_public_path__ + "static/fonts/FANGZHENGKAITIFANTI-1_0.579e893.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/suft/FANGZHENGKAITIFANTI-1_0.ttf
// module id = kM7k
// module chunks = 2